export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/schedule/resources/mounted.js